import { Component } from "@angular/core";
import { FormField } from "src/app/interfaces/form-field.model";
import { faUserGroup, faPencil, faEraser } from "@fortawesome/free-solid-svg-icons";
import { ETADateUpdationService } from "src/app/services/autopac/eta-date-updation.service";
import { NotifierService } from "angular-notifier";
import { finalize } from "rxjs/operators";

@Component({
  selector: "app-eta-date-updation",
  templateUrl: "./eta-date-updation.component.html",
  styleUrls: ["./eta-date-updation.component.css"]
})
export class EtaDateUpdationComponent {
  faUserGroup = faUserGroup;
  faPencil = faPencil;
  faEraser = faEraser;
  isUpdating = false;

  searchBooking: FormField[] = [
    {
      type: "text",
      id: "caseNumber",
      label: "Case Series",
      required: true,
      value: ""
    },
    {
      type: "text",
      id: "insurance",
      label: "Insurance",
      required: true,
      value: ""
    },
    {
      type: "date",
      id: "etaDate",
      label: "ETA Date",
      required: true,
      value: ""
    },
    {
      type: "select",
      id: "yearOfManufacture",
      label: "Year Of Manufacture",
      required: true,
      value: "",
      options: [
        { value: "", display: "Select month" },
        ...Array.from({ length: 20 }, (_, index) => {
          const year = new Date().getFullYear() - 10 + index;
          return {
            value: year.toString(),
            display: year.toString()
          };
        })
      ]
    }
  ];

  constructor(
    private etaDateUpdationService: ETADateUpdationService,
    private notifier: NotifierService,
  ) {}

  updateFields(event: any): void {
    if (event.name === "searchBooking") {
      this.searchBooking = event.fields;
    }
  }

  getFieldValue(id: string): any {
    return this.searchBooking.find(field => field.id === id)?.value ?? "";
  }

  setFieldValue(id: string, value: any): void {
    this.searchBooking = this.searchBooking.map(field =>
      field.id === id ? { ...field, value } : field
    );
  }

  formatDate(dateValue: string): string {
    if (!dateValue) {
      return "";
    }

    const parts = dateValue.split("-");
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }

    return dateValue;
  }

  updateETA(): void {
    if (this.isUpdating) return;
    if (this.searchBooking.some(field => field.required && !String(field.value ?? "").trim())) {
      this.notifier.notify("warning", "Please complete all required fields");
      return;
    }
    const caseNumber = this.getFieldValue("caseNumber");
    const insurance = this.getFieldValue("insurance");
    const etaDate = this.getFieldValue("etaDate");
    const yearOfManufacture = this.getFieldValue("yearOfManufacture");

    const payload = {
      model: {
        CaseSeries: caseNumber ?? "",
        EtaDate: this.formatDate(etaDate),
        Insurance: insurance !== null && insurance !== undefined ? String(insurance) : "",
        ManufactureYear: yearOfManufacture ? String(yearOfManufacture) : ""
      }
    };

    this.isUpdating = true;
    this.etaDateUpdationService.updateVehicleETA(payload).pipe(
      finalize(() => this.isUpdating = false),
    ).subscribe({
      next: (response) => {
        if (response.code !== 0 || response.statusCode < 200 || response.statusCode >= 300) {
          this.notifier.notify("error", response.message || "Error updating ETA");
          return;
        }
        this.clearForm();
        this.notifier.notify("success", "Case Series updated successfully.");
      },
      error: (error: any) => {
        this.notifier.notify("error", error?.message || "Error updating ETA");
        console.error("Error updating ETA", error);
      }
    });
  }

  clearForm(): void {
    this.setFieldValue("caseNumber", "");
    this.setFieldValue("insurance", "");
    this.setFieldValue("etaDate", "");
    this.setFieldValue("yearOfManufacture", "");
  }
}
